import Vue from 'vue';
import { first } from 'lodash';
import moment from 'moment';

export default {
  data() {
    return {
      loadingConfig: {
        text: 'Carregando…',
        color: '#4ea397',
        maskColor: 'rgba(255, 255, 255, 0.4)',
      },
    };
  },
  methods: {
    tooltipFormatter(item) {
      const [label, value] = item.data;
      return `${label}: ${Vue.filter('currency')(value)}`;
    },
    simpleTooltipCurrencyFormatter(item) {
      return `${item.name}: ${Vue.filter('currency')(item.data)}`;
    },
    tooltipTextFormatterAxis(item) {
      const axisItem = first(item);
      const [, value] = axisItem.data;
      return `${axisItem.name}: ${(value)}`;
    },
    decimalNumberFormatter(item) {
      return `${item.name}: ${Vue.filter('number')(item.data, '0.00')}`;
    },
    axisFormatterTruncate(qtd) {
      return item => Vue.filter('truncate')(item, qtd);
    },
    axisMoneyFormatter(label) {
      return Vue.filter('currency')(label);
    },
    getDataInicial() {
      return moment().subtract(1, 'year').startOf('month');
    },
    showChartLoading(reference) {
      this.$refs[reference].showLoading(this.loadingConfig);
    },
    hideChartLoading(reference) {
      this.$refs[reference].hideLoading();
    },
  },
};
